import { Controller } from '@hotwired/stimulus';
import { adobeTrack } from 'src/lib/adobe_track';

export default class extends Controller {
  static values = {
    siteKey: String,
    action: String,
    freshToken: Boolean,
  };

  afterSubmit(e) {
    const rolexContactEl = document.getElementById('rolex_contact');

    switch (e.detail.fetchResponse.response.status) {
      case 200:
        adobeTrack('contactForm');
        break;
      case 422:
        break;
      default:
        rolexContactEl.parentElement.insertAdjacentHTML(
          'beforeend',
          `<h2>An error has occurred, status ${e.detail.fetchResponse.response.status}.</h2>`,
        );
    }

    rolexContactEl.scrollIntoView({ behavior: 'smooth' });
  }

  textInput(e) {
    if (e.target.classList.contains('invalid')) {
      if (!e.target.value.match(/^\s*$/)) {
        e.target.classList.remove('invalid');
        const label = this.element.querySelector(`label[for=${e.target.id}].validation`);
        if (label) {
          label.style.display = 'none';
        }
      }
    }
  }

  emailInput(e) {
    if (e.target.classList.contains('invalid')) {
      if (e.target.value.match(/^[^ ]+@[^ ]+\.[^ ]{2,}$/)) {
        e.target.classList.remove('invalid');
        const label = this.element.querySelector(`label[for=${e.target.id}].validation`);
        if (label) {
          label.style.display = 'none';
        }
      }
    }
  }

  selectInput(e) {
    if (e.target.classList.contains('invalid')) {
      if (e.target.value) {
        e.target.classList.remove('invalid');
        const label = this.element.querySelector(`label[for=${e.target.id}].validation`);
        if (label) {
          label.style.display = 'none';
        }
      }
    }
  }

  checkboxInput(e) {
    if (e.target.checked) {
      e.target.classList.remove('invalid');
      const validation = this.element.querySelector(`label[for=${e.target.id}]`);
      if (validation) {
        validation.classList.remove('invalid');
      }

      const label = this.element.querySelector(`label[for=${e.target.id}].validation`);
      if (label) {
        label.parentElement.style.display = 'none';
      }
    }
  }

  submit(e) {
    if (this.freshTokenValue) {
      return;
    }

    e.preventDefault();

    const form = this.element;
    const hiddenInput = form.querySelector(`#g-recaptcha-response-data-${this.actionValue}`);
    const response = new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(
          this.siteKeyValue,
          {
            action: this.actionValue,
          },
        ).then((token) => {
          resolve(token);
        }).catch((error) => {
          reject(error);
        });
      });
    });

    response.then((token) => {
      hiddenInput.value = token;
      this.freshTokenValue = true;
      form.requestSubmit();
    });
  }
}
